<ng-container *ngIf="loading else content">
  <div>
    <i [class.white]="whitebackground"></i>
    <p *ngIf="showText"><span class="brand">somtoday</span> connect</p>
  </div>
</ng-container>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
